/*
 * @Author: yuehui
 * @Date: 2019-07-29 17:37:00
 * @LastEditTime: 2019-12-10 17:50:09
 * @LastEditors: yuehui
 * @Description: 全局过滤器
 */

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */

export function stringFloatSubtraction(first, second) {
  if (!first) {
    first = 0
  }
  if (!second) {
    second = 0
  }
  return formatFloat(parseFloat(first) - parseFloat(second))
}

export function stateText(value, all) {
  if (!value) return
  if (!Array.isArray(all)) return
  const store = all.find(v => v.value === value)
  return store ? store.text : ''
}

export function stringToFloat(data) {
  if (!data) {
    return 0
  }
  return parseFloat(data)
}
/**
 * 把数字转为百分比
 * @param {需要转成百分比的数据} num
 */
export function numToPercent(num) {
  return (num * 100) + '%'
}
/**
 * 取消小数后无效的0
 * @param {需要格式化的数据} data
 */
export function formatFloat(data) {
  if (!data) {
    return '0'
  }
  return parseFloat(parseFloat(data).toFixed(2)) + ''
}
/**
 * 缩略图
 * @param {需要格式化的数据} data
 */
export function get400Img(url) {
  if (!url) {
    return ''
  }
  return url + '?imageView2/0/w/400/h/400'
}

/**
 * 缩略图
 * @param {需要格式化的数据} data
 */
export function get400ImgByName(name) {
  if (!name) {
    return ''
  }
  return process.env.VUE_APP_QINIU_URL + '/' + name + '?imageView2/0/w/400/h/400'
}

export function formatDate(date) {
  if (!date) {
    return ''
  }
  return date.substring(0, 10)
}

export function dateToYMD(date) {
  if (!date) {
    return ''
  }
  var y = 1900 + date.getYear()
  var m = '0' + (date.getMonth() + 1)
  var d = '0' + date.getDate()
  return y + '-' + m.substring(m.length - 2, m.length) + '-' + d.substring(d.length - 2, d.length)
}

export function getImageSmall(imageNamme) {

}

export function getImage(imageNamme) {

}

export function getFullUserName(item) {
  if (!item.village_name || !item.customer_name) {
    return ''
  }
  return (item.customer_name ? item.customer_name : '') + '-' + (item.village_name ? item.village_name : '')
}
